<template>
    <el-form ref="form" :model="model" label-width="200px">
        <el-tabs>
            <el-tab-pane
                :key="tab.label"
                v-for="tab in config.formFields"
                :label="tab.label"
            >
                <div
                    :model="model"
                    :root-config="rootConfig"
                    :is="item.component"
                    :options="item.options"
                    v-for="item in tab.body"
                    :key="item._uid"
                ></div>

                <el-form-item
                    v-if="isVisibleInCurrentShop(field)"
                    :key="field.name"
                    :label="field.label"
                    v-for="field in tab.fields"
                    :class="{ 'form-field': isCustomerSupport() }"
                >
                    <div
                        :placeholder="field.placeholder"
                        @input="setModel(field.name)"
                        :root-config="rootConfig"
                        :options="field.options"
                        :type="field.type"
                        :is="field.component"
                        v-model="model[field.name]"
                    ></div>
                </el-form-item>
            </el-tab-pane>
        </el-tabs>
        <el-form-item>
            <el-button type="primary" @click="onSubmit">Save</el-button>
            <el-button
                v-if="!isCustomerSupport()"
                @click="
                    $router.push({
                        name: 'admin',
                        params: { id: 'all', action: 'index' },
                    })
                "
                >Cancel</el-button
            >
        </el-form-item>
    </el-form>
</template>

<script>
import api from '../libs/api';
import encryptStorage from '../libs/encryptStorage';

export default {
    name: 'v-crud-new',

    props: ['config', 'rootConfig', 'siteId', 'params', 'id'],

    data() {
        return {
            model: {},
            userRole: encryptStorage.getItem('ur'),
        };
    },
    methods: {
        isVisibleInCurrentShop(field) {
            if (field.show_for_shop_ids && field.show_for_shop_ids.length > 0) {
                return field.show_for_shop_ids.includes(this.siteId);
            }
            return true;
        },
        setModel() {
            if (typeof this.model[name] === 'undefined') {
                this.model = Object.assign({}, this.model);
            }
        },
        onSubmit() {
            let params = {};

            if (this.config.singleRootObject) {
                params[this.config.singleRootObject] = this.model;
            } else {
                params = this.model;
            }

            api.res
                .save(params)
                .then((res) => {
                    if (this.isCustomerSupport()) {
                        encryptStorage.setItem(
                            'customer_support_coupon',
                            res.data.name
                        );
                        this.$router.push({
                            name: 'admin',
                            params: { id: 'all', action: 'index' },
                        });
                    } else {
                        this.$router.push({
                            name: 'admin',
                            params: { id: 'all', action: 'index' },
                        });
                    }
                })
                .catch(api.errorHandler);
        },
        isCustomerSupport() {
            return this.userRole === 'CustomerSup';
        },
    },
};
</script>

<style>
.form-field {
    max-width: 800px;
}
</style>



// WEBPACK FOOTER //
// VueCrudNew.vue?580e5076